<template>
    <main class="page integration">

        <div v-if="integration !== false" class="integration-single">

            <section class="auto start medium background-light">
                <div class="inner">
                    <div class="title">
                        <div class="logo">
                            <img :alt="integration.main.img_alt" :src="integration.main.img">
                        </div>
                        <h1 v-html="integration.main.title"></h1>
                    </div>
                </div>
                <div class="background">
                    <div class="rect top-left"></div>
                    <div class="rect top-right"></div>
                </div>
            </section>

            <section class="light round">
                <div class="inner">

                    <div class="content-large center">
                        <h2 class="teaser">{{integration.main.description}}</h2>
                        <div class="actions">
                            <a class="btn blue uppercase" href="https://app.sleekplan.com/sign-up" rel="nofollow"><b>Get started</b></a> 
                            <a v-if="integration.main.install" class="btn uppercase" :href="integration.main.install" rel="nofollow">Help Docs</a>
                            <a v-else class="btn uppercase" href="https://sleekplan.com/features/" rel="nofollow">Learn more</a>
                        </div>
                    </div>

                </div>
            </section>

            <section class="white">
                <div class="inner">

                    <div class="integration-item">
                        <div class="row item" v-for="items in integration.items" v-bind:key="items.title">
                            <div class="col-xs-12 col-sm-5 main" v-if="items.img">
                                <div>
                                    <h3 v-html="items.title"></h3>
                                    <span class="description" v-html="items.text"></span>
                                </div>
                            </div>
                            <div class="col-xs-12 col-sm-7 data" v-if="items.img">
                                <picture>
                                    <source :srcset="items.img.replace('.jpg', '.webp')" type="image/webp">
                                    <source :srcset="items.img" type="image/jpeg"> 
                                    <img :src="items.img" class="image" :title="items.title.replace(/<[^>]*>?/gm, '')" :alt="items.title.replace(/<[^>]*>?/gm, '')">
                                </picture>
                            </div>
                            <div class="col-xs-12 col-sm-12 main" v-if="!items.img">
                                <div class="center">
                                    <h3 v-html="items.title"></h3>
                                    <span class="description" v-html="items.text"></span>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </section>

            <section class="light end">
                <div class="inner">
                    
                    <div class="content-large center">
                        <div class="bottom-logos">
                            <img src="@/assets/media/logo/logo.svg" title="Sleekplan">
                            <svg xmlns='http://www.w3.org/2000/svg' class='ionicon' viewBox='0 0 512 512'><title>Heart</title><path d='M352.92 80C288 80 256 144 256 144s-32-64-96.92-64c-52.76 0-94.54 44.14-95.08 96.81-1.1 109.33 86.73 187.08 183 252.42a16 16 0 0018 0c96.26-65.34 184.09-143.09 183-252.42-.54-52.67-42.32-96.81-95.08-96.81z' fill='none' stroke='currentColor' stroke-linecap='round' stroke-linejoin='round' stroke-width='32'/></svg>
                            <img :alt="integration.main.img_alt" :src="integration.main.img">
                        </div>
                        <h2>{{integration.main.footer}}</h2>
                        <span>You can simply try the Sleekplan Business Plan 30 days for free without any conditions. If you are satisfied, you can switch to a suitable plan afterward.</span>
                        <div class="button-area">
                            <a href="https://app.sleekplan.com/sign-up/" class="btn uppercase" rel="nofollow">Get started for free</a>
                            <span class="btn-sub">No credit card required</span>
                        </div>
                    </div>
                    
                </div>
            </section>

        </div>

        <div v-else class="integration-list">

            <section class="auto start background-white">
                <div class="inner">
                    <div class="title large">
                        <h1>Integrated with the tools you know and love.</h1>
                        <h2>Get more done with Sleekplan's plugins and integrations</h2>
                    </div>
                </div>
                <div class="background">
                    <div class="rect top-left"></div>
                    <div class="rect top-right"></div>
                </div>
            </section>

            <section class="white">
                <div class="inner">
                    
                    <div class="integration-items">

                        <div v-for="(integration_item, index) in Object.fromEntries(Object.entries(integrations).filter(([key, value]) => value.highlight === true && key))" v-bind:key="index">
                            <a v-if="integration_item.main.link" :href="integration_item.main.link" target="_blank" rel="nofollow noopener">
                                <div class="item-box">
                                    <div class="item-icon">
                                        <img :src="integration_item.main.img" :alt="integration_item.main.img_alt">
                                    </div>
                                    <div class="item-content">
                                        <h2>{{((integration_item.main.name) ? integration_item.main.name : index.charAt(0).toUpperCase() + index.slice(1))}}</h2>
                                        <span>{{integration_item.main.description}}</span>
                                    </div>
                                    <div class="item-more">
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="ionicon"><title>Arrow Forward</title><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="48" d="M268 112l144 144-144 144M392 256H100"></path></svg>
                                    </div>
                                </div>
                            </a>
                            <a v-else-if="integration_item.items" :href="'/integration/' + index + '/'">
                                <div class="item-box">
                                    <div class="item-icon">
                                        <img :src="integration_item.main.img" :alt="integration_item.main.img_alt">
                                    </div>
                                    <div class="item-content">
                                        <h2>{{((integration_item.main.name) ? integration_item.main.name : index.charAt(0).toUpperCase() + index.slice(1))}}</h2>
                                        <span>{{integration_item.main.description}}</span>
                                    </div>
                                    <div class="item-more">
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="ionicon"><title>Arrow Forward</title><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="48" d="M268 112l144 144-144 144M392 256H100"></path></svg>
                                    </div>
                                </div>
                            </a>
                            <span v-else>
                                <div class="item-box">
                                    <div class="item-icon">
                                        <img :src="integration_item.main.img" :alt="integration_item.main.img_alt">
                                    </div>
                                    <div class="item-content">
                                        <h2>{{((integration_item.main.name) ? integration_item.main.name : index.charAt(0).toUpperCase() + index.slice(1))}}</h2>
                                        <span>{{integration_item.main.description}}</span>
                                    </div>
                                </div>
                            </span>
                        </div>
                        <div v-for="(integration_item, index) in Object.fromEntries(Object.entries(integrations).filter(([key, value]) => value.highlight !== true && key))" v-bind:key="index">
                            <a v-if="integration_item.main.link" :href="integration_item.main.link" target="_blank" rel="nofollow">
                                <div class="item-box">
                                    <div class="item-icon">
                                        <img :src="integration_item.main.img" :alt="integration_item.main.img_alt">
                                    </div>
                                    <div class="item-content">
                                        <h2>{{((integration_item.main.name) ? integration_item.main.name : index.charAt(0).toUpperCase() + index.slice(1))}}</h2>
                                        <span>{{integration_item.main.description}}</span>
                                    </div>
                                    <div class="item-more">
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="ionicon"><title>Arrow Forward</title><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="48" d="M268 112l144 144-144 144M392 256H100"></path></svg>
                                    </div>
                                </div>
                            </a>
                            <a v-else-if="integration_item.items" :href="'/integration/' + index + '/'">
                                <div class="item-box">
                                    <div class="item-icon">
                                        <img :src="integration_item.main.img" :alt="integration_item.main.img_alt">
                                    </div>
                                    <div class="item-content">
                                        <h2>{{((integration_item.main.name) ? integration_item.main.name : index.charAt(0).toUpperCase() + index.slice(1))}}</h2>
                                        <span>{{integration_item.main.description}}</span>
                                    </div>
                                    <div class="item-more">
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="ionicon"><title>Arrow Forward</title><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="48" d="M268 112l144 144-144 144M392 256H100"></path></svg>
                                    </div>
                                </div>
                            </a>
                            <span v-else>
                                <div class="item-box">
                                    <div class="item-icon">
                                        <img :src="integration_item.main.img" :alt="integration_item.main.img_alt">
                                    </div>
                                    <div class="item-content">
                                        <h2>{{((integration_item.main.name) ? integration_item.main.name : index.charAt(0).toUpperCase() + index.slice(1))}}</h2>
                                        <span>{{integration_item.main.description}}</span>
                                    </div>
                                </div>
                            </span>
                        </div>

                    </div>

                </div>
            </section>

        </div>

    </main>
</template>

<script>
export default {


    /** ----------------------------------------------------
     * View => Base data
     ----------------------------------------------------- */
    data() {
        
        // data
		return {
            id: this.$route.params.id,
            integration: false,
            integrations: {

                /**
                 * /intercom
                 */
                'intercom': {
                    highlight: true,
                    main: {
                        name: false,
                        title: '<b>Capture feedback</b> from within your Intercom Messenger',
                        description: 'Track and share the feedback you get in your Intercom messenger and live chat. Add your Roadmap and Changelog to your messenger Home.',
                        img: 'https://storage.sleekplan.com/static/integrations/intercom.png',
                        img_alt: 'Track Feedback with Intercom',
                        footer: 'Connect your Messenger with Sleekplan',
                        link: false
                    },
                    items: [
                        {
                            title: '<span>Add a</span> feedback board <span>&</span> changelog <span>to your messenger</span>',
                            text: ``,
                            img: '/assets/pages/integration/intercom-1.jpg',
                        },
                        {
                            title: 'Search, share <span>and</span> create suggestions <span>within your Intercom Messenger</span>',
                            text: ``,
                            img: '/assets/pages/integration/intercom-2.jpg',
                        },
                        {
                            title: 'Notify <span>your user as soon as the status of an item changed</span>',
                            text: ``,
                            img: '/assets/pages/integration/intercom-3.jpg',
                        }
                    ],
                    meta: {
                        title: 'Feedback, Roadmap and Changelog for Intercom Messenger',
                    },
                },

                /**
                 * /intercom
                 */
                'github': {
                    highlight: true,
                    main: {
                        name: false,
                        title: '<b>Display</b> and <b>discuss</b> Github Issues on your website',
                        description: 'Sync the feedback, suggestions, and issues you receive via Github Issues with the Sleekplan widget on your website.',
                        img: 'https://storage.sleekplan.com/static/integrations/github.png',
                        img_alt: 'GitHub Issues website widget',
                        footer: 'Connect GitHub Issues to your website',
                        link: false
                    },
                    items: [
                        {
                            title: '<span>Sync</span> GitHub Issues <span>with your Sleekplan feedback widget</span>',
                            text: ``,
                            img: '/assets/pages/integration/github-1.jpg',
                        },
                        {
                            title: 'Instantly update <span>GitHub Issues, whenever you update posts on your roadmap</span>',
                            text: ``,
                            img: '/assets/pages/integration/github-2.jpg',
                        },
                        {
                            title: 'Keep your users up to date <span>as soon as things are done</span>',
                            text: ``,
                            img: '/assets/pages/integration/github-3.jpg',
                        }
                    ],
                    meta: {
                        title: 'Sync Github Issues with a Widget for your website',
                    },
                },

                /**
                 * /zapier
                 */
                'zapier': {
                    main: {
                        name: false,
                        description: 'Easily integrate Sleekplan with 1000+ other apps on Zapier.',
                        img: 'https://storage.sleekplan.com/static/integrations/zapier.png',
                        img_alt: 'Connect Sleekplan with 100+ apps',
                        link: 'https://zapier.com/apps/sleekplan/integrations'
                    },
                },

                /**
                 * /cloudflare
                 */
                'cloudflare': {
                    main: {
                        name: false,
                        description: 'One click solution to integrate Sleekplan into any Cloudflare powered app.',
                        img: 'https://storage.sleekplan.com/static/integrations/cloudflare.png',
                        img_alt: 'Connect Sleekplan with 100+ apps',
                        link: false
                    },
                },

                /**
                 * /chrome
                 */
                'chrome': {
                    main: {
                        name: false,
                        description: 'Manage feedback everywhere! Create posts or vote for existing posts on behalf of your users, share links and update post status.',
                        img: 'https://storage.sleekplan.com/static/integrations/chrome.png',
                        img_alt: 'Connect Sleekplan with 100+ apps',
                        link: false
                    },
                },

                /**
                 * /slack
                 */
                'slack': {
                    highlight: true,
                    main: {
                        name: false,
                        title: '<b>Manage customer feedback</b> directly in Slack',
                        description: 'Create feedback and changelog updates from Slack and get notified about new feedback, comments, CSAT-votes and subscriber.',
                        img: 'https://storage.sleekplan.com/static/integrations/slack.png',
                        img_alt: 'Manage customer feedback in Slack',
                        footer: 'Connect your Slack channel with Sleekplan',
                        link: false,
                        install: 'https://help.sleekplan.com/en/articles/5521460-slack-integration'
                    },
                    items: [
                        {
                            title: 'Track User Feedback',
                            text: `Add feedback on behalf of your customers and keep them in the know about any updates`,
                            img: '/assets/pages/integration/slack-1.jpg',
                        },
                        {
                            title: 'Publish Updates',
                            text: `Publish updates and announcements directly from Slack`,
                            img: '/assets/pages/integration/slack-2.jpg',
                        },
                        {
                            title: 'Get Notified',
                            text: `Keep your team in sync with all important notifications form Sleekplan.`,
                            img: '/assets/pages/integration/slack-3.jpg',
                        }
                    ],
                    meta: {
                        title: 'All-in-one: Feedback, Roadmap and Changelog for Slack',
                    },
                },

                /**
                 * /wordpress
                 */
                'wordpress': {
                    main: {
                        name: 'WordPress',
                        description: 'Integrate Sleekplan with single sign-on into any Wordpress powered website.',
                        img: 'https://storage.sleekplan.com/static/integrations/wordpress.png',
                        img_alt: 'Connect Sleekplan with 100+ apps',
                        link: false
                    },
                },

                /**
                 * /jira
                 */
                'jira': {
                    main: {
                        name: false,
                        description: 'Collect and Discuss in-app user feedback and keep everyone in sync straight from Jira',
                        img: 'https://storage.sleekplan.com/static/integrations/jira.png',
                        img_alt: 'Sleekplan for Jira',
                        link: false,
                    },
                },

                /**
                 * /devops
                 */
                 'devops': {
                    main: {
                        name: 'Azure DevOps',
                        description: 'Collect and Discuss in-app user feedback and keep everyone in sync straight from Azure DevOps',
                        img: 'https://storage.sleekplan.com/static/integrations/devops.png',
                        img_alt: 'Connect Sleekplan with 100+ apps',
                        link: false
                    },
                },

                /**
                 * /clickup
                 */
                'clickup': {
                    highlight: true,
                    main: {
                        name: false,
                        title: '<b>Turn User Feedback</b> into ClickUp Tasks',
                        description: 'Improve your feedback management and productivity by using ClickUp together with Sleekplan. Create a new Task in ClickUp from feedback posts or link posts to existing Tasks. Sleekplan will keep status updates in sync and notify your users once a task is completed.',
                        img: 'https://storage.sleekplan.com/static/integrations/clickup.png',
                        img_alt: 'Sleekplan - User Feedback for ClickUp',
                        footer: 'Connect Sleekplan with ClickUp',
                        link: false,
                        install: 'https://help.sleekplan.com/en/articles/5787733-clickup-integration'
                    },
                    items: [
                        {
                            title: 'Create New Tasks',
                            text: `Push feedback and suggestions from Sleekplan to ClickUp.`,
                            img: '/assets/pages/integration/clickup-1.jpg',
                        },
                        {
                            title: 'Link Existing Tasks',
                            text: `Link existing ClickUp tasks to posts on your feedback baord.`,
                            img: '/assets/pages/integration/clickup-2.jpg',
                        },
                        {
                            title: 'Sync Status Updates',
                            text: `Keep your users in sync with all important notifications and status updates.`,
                            img: '/assets/pages/integration/clickup-3.jpg',
                        }
                    ],
                    meta: {
                        title: 'User Feedback Integration for ClickUp',
                    },
                },

            }
        };

    },


    /** ----------------------------------------------------
     * View => Methods
     ----------------------------------------------------- */
    methods: {

        /**
         *  scrolling
         */
        scrolling() {},

        /**
         *  integrations
         */
        load_integrations( id ) {
            
            // check if we have a service
            if( this.integrations[id] ) {
                // set data
                this.integration = this.integrations[id];
                // stop
                return true;
            // check if we have a redirect
            } else if( ! id ) {
                // set to false
                this.integration = false;
                // stop
                return true;
            // if we have nothing
            } else {   
                // load 404
                location.href = '/error';
                // stop
                return true;
            }

       },

	},


    /** ----------------------------------------------------
     * View => On Mount
     ----------------------------------------------------- */
    mounted() {

        // add class
        this.$parent.$refs['home-header'].menu_transparent = false;

        // load stats
        this.load_integrations( this.id );

    },


    /** ----------------------------------------------------
     * View => On Destroyed
     ----------------------------------------------------- */
    destroyed() {

        // remove class
        this.$parent.$refs['home-header'].menu_transparent = false;

    },


    /** ----------------------------------------------------
     * View => Before Route Update
     ----------------------------------------------------- */
    watch: {
        // whenever question changes, this function will run
        $route() {
            // set new id
            this.id = this.$route.params.id;
            // load stats
            this.load_integrations( this.id );
            // load new changelog id
            this.$forceUpdate();
        }
    },


    /** ----------------------------------------------------
     * Header
     ----------------------------------------------------- */
    head: {
        // Meta title
        title: function () {
            // custom title
            return {
                inner: this.integrations[this.$route.params.id].meta.title,
                separator: '|',
                complement: 'Sleekplan'
            };
        },
        // Meta tags
        meta: [
            { 
                name: 'description', 
                content: '', 
                id: 'desc' 
            },
            { name: 'robots', content: 'index,follow' },
        ],
        // Link tags
        link: [
            { 
                rel: 'canonical', 
                href: 'https://sleekplan.com' + location.pathname,  
                id: 'canonical' 
            },
        ]
    }


}
</script> 